import { SufixoAbreviacaoNumero } from '../model/numero/sufixo-abreviacao-numero.model';

export const SUFIXOS_ABREVIACAO_NUMERO: SufixoAbreviacaoNumero[] = [
  { divisor: 1_000_000_000, sufixo: 'B' },
  { divisor: 1_000_000, sufixo: 'M' },
  { divisor: 1_000, sufixo: 'k' }
];
